//src/services/users
import api from '../api/axios';

const BASE_URL = 'api/accounts';

// Get all users (filtered by tenant via backend get_queryset)
export const getUsers = () => {
  return api.get(`${BASE_URL}/users/`);
};

// Create a new user (only for managers)
export const createUser = (userData) => {
  return api.post(`${BASE_URL}/users/`, userData);
};

// Delete a user (only for managers)
export const deleteUser = (userId) => {
  return api.delete(`${BASE_URL}/users/${userId}/`);
};

// Update a user (only for managers)
export const updateUser = (userId, userData) => {
  return api.patch(`${BASE_URL}/users/${userId}/`, userData);
};

// Update user password (only for managers)
export const updateUserPassword = (userId, passwordData) => {
  return api.patch(`${BASE_URL}/users/${userId}/`, passwordData);
};

// Change own password (verifies current password)
export const changePassword = (data) => {
  return api.post(`${BASE_URL}/users/change_password/`, data);
};

// Get current logged in user info
export const getCurrentUser = () => {
  return api.get(`${BASE_URL}/users/me/`);
};

// Update current logged in user info
export const updateCurrentUser = (data) => {
  return api.patch(`${BASE_URL}/users/update_me/`, data);
};

// Logout current user
export const logoutUser = () => {
  return api.post(`${BASE_URL}/users/logout/`);
};

// Get status of all users
export const getUsersStatus = () => {
  return api.get(`${BASE_URL}/users/status/`);
};

// Update active status of current user
export const updateActiveStatus = (isActive = true) => {
  return api.post(`${BASE_URL}/users/active_check/`, { is_active: isActive });
};

// User tags
export const getUserTags = () => {
  return api.get(`${BASE_URL}/user-tags/`);
};

export const createUserTag = (data) => {
  return api.post(`${BASE_URL}/user-tags/`, data);
};

export const deleteUserTag = (tagId) => {
  return api.delete(`${BASE_URL}/user-tags/${tagId}/`);
};